import { Box } from "@mui/material";
import FlightIcon from "@mui/icons-material/Flight";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import EggIcon from "@mui/icons-material/Egg";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import PoolIcon from "@mui/icons-material/Pool";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import CampaignIcon from "@mui/icons-material/Campaign";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import BusAlertIcon from "@mui/icons-material/BusAlert";
import StoreIcon from "@mui/icons-material/Store";
import CarCrashIcon from "@mui/icons-material/CarCrash";

export default function Accommodation() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "1rem",
      }}
    >
      <Box
        component="h1"
        sx={{
          fontSize: "3rem",
          textAlign: "center",
          "@media (max-width:600px)": { fontSize: "2rem" },
        }}
      >
        <u>Suggested Hotels</u>
      </Box>
      <h2 style={{ textAlign: "center" }}>Hyatt House Winnipeg South</h2>
      <a href="https://www.hyatt.com/hyatt-house/en-US/ywgxw-hyatt-house-winnipeg-south-outlet-collection">
        Hotel website
      </a>
      <Box component="ul" sx={{ "@media (max-width:600px)": { padding: 0 } }}>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <FlightIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          20 min to airport
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsCarIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          13 min from the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <AccessibilityIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Suites are available at the hotel, including accessibility suites
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <LocalParkingIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Free parking
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <EggIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Free breakfast
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <RestaurantIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Restaurant/bar in the hotel
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <PoolIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Pool and fitness center
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsWalkIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Walking distance to numerous restaurants, stores, and the grocery
          store
        </Box>
      </Box>
      <div style={{ marginBottom: "1rem" }}>Group discount: TBD</div>
      <h2 style={{ textAlign: "center" }}>Hilton Garden Inn Winnipeg South</h2>
      <a href="https://www.hilton.com/en/hotels/ywgmngi-hilton-garden-inn-winnipeg-south/">
        Hotel website
      </a>
      <Box component="ul" sx={{ "@media (max-width:600px)": { padding: 0 } }}>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <FlightIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          20 min to airport
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsCarIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          15 min from the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <AirportShuttleIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Airport shuttle available
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <LocalParkingIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Free parking
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <RestaurantIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Restaurant in the hotel
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <PoolIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Pool and fitness center
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsWalkIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Walking distance to numerous restaurants, stores, and the grocery
          store
        </Box>
      </Box>
      <div style={{ marginBottom: "1rem" }}>Group discount: TBD</div>
      <h2 style={{ textAlign: "center" }}>Best Western</h2>
      <a href="https://www.bestwestern.com/en_US/book/hotels-in-headingley/best-western-plus-winnipeg-west/propertyCode.63016.html">
        Hotel website
      </a>
      <Box component="ul" sx={{ "@media (max-width:600px)": { padding: 0 } }}>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <FlightIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          23 min to airport
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsCarIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />6 min
          from the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <LocalParkingIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Free parking
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <RestaurantIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Restaurant in the hotel
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <PoolIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Pool and fitness center
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <CarCrashIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Would require a car as there are no stores in easy walking distance
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <PriorityHighIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Of note there is a Flying J beside the hotel and the 18 wheelers park
          in the back when taking breaks -- we would recommend asking for a room
          in the center of the hotel on the west side to minimize sound.
        </Box>
      </Box>
      <div style={{ marginBottom: "1rem" }}>Group discount: TBD</div>
      <Box
        component="h1"
        sx={{
          fontSize: "3rem",
          textAlign: "center",
          "@media (max-width:600px)": { fontSize: "2rem" },
        }}
      >
        <u>
          Suggested areas for
          <br />
          <u style={{ fontFamily: "Pinyon" }}>AirBnB</u> &{" "}
          <u style={{ fontFamily: "Pinyon" }}>VRBO</u>
        </u>
      </Box>
      <h2 style={{ textAlign: "center" }}>Headingley</h2>
      <Box
        component="ul"
        sx={{
          marginBottom: "1rem",
          "@media (max-width:600px)": { padding: 0 },
        }}
      >
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <FlightIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          25-30 min to airport
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsCarIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          5-7 min from the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <CampaignIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Very quiet community
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <BusAlertIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          No city bus service
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <StoreIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Village store, 3 restaurants and one bar
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <CarCrashIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Will require a car, can get Uber from the airport to drop off but Uber
          cannot pick up in Headingley
        </Box>
      </Box>
      <h2 style={{ textAlign: "center" }}>Charleswood</h2>
      <Box
        component="ul"
        sx={{
          marginBottom: "1rem",
          "@media (max-width:600px)": { padding: 0 },
        }}
      >
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <FlightIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          23 min to airport
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsCarIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          5-8 min from the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <CarCrashIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Most areas will require a car
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsBusIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          City bus service is available for touring but cannot be taken to the
          venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <StoreIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Community has grocery, drug stores and restaurants, no clothing stores
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <PriorityHighIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          <b>
            DO NOT recommend houses listed on Westgrove Way near the perimeter
          </b>
        </Box>
      </Box>
      <h2 style={{ textAlign: "center" }}>Westwood</h2>
      <Box
        component="ul"
        sx={{
          marginBottom: "1rem",
          "@media (max-width:600px)": { padding: 0 },
        }}
      >
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <FlightIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          18 min to airport
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsCarIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          5-7 min from the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <CarCrashIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Could be done without a car depending on which area of the community
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsBusIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          City bus is available for touring but cannot take you to the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <StoreIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Close to shopping area that has Canadian Tire, Winners, Sobeys,
          Walmart, Shoppers Drug Mart, Tim Hortons, Wendy's, etc.
        </Box>
      </Box>
      <h2 style={{ textAlign: "center" }}>Crestview</h2>
      <Box
        component="ul"
        sx={{
          marginBottom: "1rem",
          "@media (max-width:600px)": { padding: 0 },
        }}
      >
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <FlightIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          18 min to airport
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsCarIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          5-7 min from the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <CarCrashIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Could be done without a car depending on which area of the community
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsBusIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          City bus is available for touring but cannot take you to the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <StoreIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Close to shopping area that has Canadian Tire, Winners, Sobeys,
          Walmart, Shoppers Drug Mart, Tim Hortons, Wendy's, etc.
        </Box>
      </Box>
      <h2 style={{ textAlign: "center" }}>
        St. James West (closer to Moray Ave)
      </h2>
      <Box
        component="ul"
        sx={{
          marginBottom: "1rem",
          "@media (max-width:600px)": { padding: 0 },
        }}
      >
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <FlightIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          15 min to airport
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsCarIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          10-12 min from the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <CarCrashIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          Would require a car
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <DirectionsBusIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          City bus is available for touring but cannot take you to the venue
        </Box>
        <Box
          component="li"
          sx={{
            display: "flex",
            width: "50vw",
            "@media (max-width:600px)": { width: "90vw" },
            alignItems: "center",
            mb: 1,
          }}
        >
          <StoreIcon sx={{ color: "rgb(80, 97, 117)", mr: 1 }} />
          No stores nearby, however there is a Shoppers Drug Mart, Boston Pizza,
          McDonalds, and two Tim Hortons
        </Box>
      </Box>
    </div>
  );
}
